export default __webpack_public_path__ + "static/Telecel-Icon-White-8a93cf8d52f5a82976c4e2216ad55679.png";